import {getCookie, setCookie} from './cookie';
import Url from './Url';

// Fetch context from query params or cookie
export default function fetchContext(uuid, ...cookieDetails) {
	let contextGuid = Url.getParam('context.guid');
	let contextParams = Url.getParam('context.params');
	let contextInit = false;
	if (contextGuid) {
		setCookie('context.guid', contextGuid, 0.5, ...cookieDetails);
		// Override params if new guid comes, even if its null so that previous one is deleted
		setCookie('context.params', contextParams, 0.5, ...cookieDetails);
		setCookie('context.init', contextInit.toString(), 0.5, ...cookieDetails);
	}
	else {
		contextGuid = getCookie('context.guid');
		contextParams = getCookie('context.params');
		contextInit = getCookie('context.init');
		// When null is saved to cookie it turns into string, thus sanitize it's value
		contextParams = contextParams === 'null' ? null : contextParams;

		// If guid is not available, create one
		if (!contextGuid) {
			contextGuid = uuid.v4();
			contextInit = true;
			setCookie('context.guid', contextGuid, 0.5, ...cookieDetails);
			setCookie('context.init', contextInit.toString(), 0.5, ...cookieDetails);
		}
	}
	return [contextGuid, contextParams, contextInit];
};